<div class="db-hosting-tools">

  <div [ngClass]="{'db-page-with-banner': hasHostingBanner}" id="db-hosting-tools-tooltip">
    <db-ai-builder-demo-banner *ngIf="demoUser"
                               [title]="'Hosting Management'" [features]="features" [class]="'with_margins medium_width'">
    </db-ai-builder-demo-banner>
    <ds-mobile-page-title></ds-mobile-page-title>
    <div class="db-hosting-tools__main-content" [ngClass]="{'disabled-with-overlay': demoUser}">
      <div class="db-hosting-tools__group" *ngIf="!website?.parentId">
        <div class="db-hosting-tools__group-each website_caching">
          <div class="db-hosting-tools__group-each-cache clear_caching" [ngClass]="{'ds-lazy-load': !!loading}">
            <div class="db-hosting-tools__group-description">
              <p>{{'text_clearSiteCache' | dbText}}</p>
              <p [innerHTML]="'text_enableClearCacheDesc' | dbText" ></p>
            </div>
            <div class="db-switch-wrap">
              <input id="website-cache-switcher" class="ds-switcher-black ds-control-small auto-optimize-settings" type="checkbox"
                     [checked]="enableCache" (change)="enableCacheForWebsite()">
              <label for="website-cache-switcher"
                     [ngClass]="{'db-button_disabled' : loading || clearCacheLoading || website?.type === 'staging'}">
                <span class="ds-switcher-control"></span>
              </label>
            </div>
          </div>

          <div class="db-hosting-tools__group-each-cache cache-ttl" *ngIf="enableCache && !loading">
            <div class="db-hosting-tools__group-description">
              <div><p class="db-hosting-tools__sub-header">{{'text_cacheFlushedIn' | dbText}}</p></div>
              <div class="db-hosting-tools__group-button db-hosting-tools__group-button-indent">
                <ds-dropdown [formControl]="cacheTTL" [dsDropDownScrollingElement]="'db-hosting-tools'"
                             (onOptionChoose)="enableBtn = true"
                             [dsDropdownWidth]="'360px'" [value]="cacheTTL.value" [dsDropdownOptions]="cacheTTLOptions">

                </ds-dropdown>
              </div>
            </div>

            <div class="db-hosting-tools__group-button">
              <a class="ds-btn-black" [ngClass]="{'ds-btn-disabled': cacheTTLloading || !enableBtn}"  (click)="changeCacheTTL()">
                <span *ngIf="!cacheTTLloading" >{{'text_saveTags' | dbText | lowerCaseSpecificWords}}</span>
                <db-loading-circular-spinner *ngIf="cacheTTLloading"></db-loading-circular-spinner>
              </a>
            </div>
          </div>

          <div class="db-hosting-tools__group-each-cache clear_cache_div" *ngIf="enableCache && !loading">
            <div class="db-hosting-tools__group-description">
              <p class="db-entirely-desc" [innerHTML]="'text_clearCacheDesc' | dbText" ></p>
            </div>

            <div class="db-hosting-tools__group-button">
              <a class="ds-btn-black" [ngClass]="{'ds-btn-disabled': clearCacheLoading}" (click)="clearCache()">
                <span *ngIf="!clearCacheLoading" >{{'text_clearCache' | dbText | lowerCaseSpecificWords}}</span>
                <db-loading-circular-spinner *ngIf="clearCacheLoading"></db-loading-circular-spinner>
              </a>
            </div>
          </div>

          <div class="db-hosting-tools__group-each-cache clear_cache_exclude" *ngIf="enableCache && !loading">
            <div class="db-hosting-tools__group-description">
              <div>
                <div class="db-hosting-tools__header">
                  <p class="db-hosting-tools__sub-header">{{'text_excludeURLsFromCache' | dbText}}</p>
                  <i class="db-icon db-icon-info-lined" [dsTooltip]="'text_supports_reg_expresions' | dbText"
                     [dsTooltipPosition]="'top'" [dsTooltipAlign]="'right'"></i>
                </div>
              </div>
              <input type="text" class="ds-input" placeholder="Enter the URL"/>
              <div class="db-hosting-tools__tag-editor" *ngIf="excludePages">
                <div *ngFor="let page of excludePages; let i = index" [class]="'exclude_page' + i" >
                  <div class="tag-editor-tag" (click)="editPageValue(i)">{{ page }}</div>
                  <input type="text" [value]="page" (keyup)="editExcludePage(i, $event)" [class]="'' + i + ' exclude_page_input_' + i"/>
                  <div class="tag-editor-delete" (click)="toolsRemoveExludePages(page)"><i></i></div>
                </div>
                <div [class]="'active exclude_page' + excludePages.length" [ngClass]="{'has-pages': excludePages?.length}">
                  <input type="text" [value]="" [formControl]="addedExcludedPageValue" (keyup)="addExcludePage($event)"/>
                </div>
              </div>
            </div>

            <div class="db-hosting-tools__group-button">
              <a class="ds-btn-black" [ngClass]="{'ds-btn-disabled': excludePagesLoading || (!excludePages.length
              && !excludePagesDisable)}"  (click)="toolsSetExludePages()">
                <span *ngIf="!excludePagesLoading" >{{'text_saveTags' | dbText | lowerCaseSpecificWords}}</span>
                <db-loading-circular-spinner *ngIf="excludePagesLoading"></db-loading-circular-spinner>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="db-hosting-tools__group" *ngIf="!website?.parentId">
        <div class="db-hosting-tools__group-each website_caching">
          <div class="db-hosting-tools__group-each-cache clear_caching ob_cache" [ngClass]="{'ds-lazy-load': !!loadingOb}">
            <div class="db-hosting-tools__group-description">
              <p>{{'text_clearSiteObCache' | dbText}}</p>
              <p [innerHTML]="'text_enableClearObCacheDesc' | dbText" ></p>
            </div>
            <div class="db-switch-wrap">
              <input id="website-ob-cache-switcher" class="ds-switcher-black ds-control-small auto-optimize-settings" type="checkbox"
                     [checked]="enableObCache" (change)="enableObCacheForWebsite()">
              <label for="website-ob-cache-switcher"
                     [ngClass]="{'db-button_disabled' : loadingOb || clearObCacheLoading || website?.type === 'staging'}">
                <span class="ds-switcher-control"></span>
              </label>
            </div>
          </div>

          <div class="db-hosting-tools__group-each-cache clear_cache_div" *ngIf="enableObCache && !loadingOb">
            <div class="db-hosting-tools__group-description">
              <p class="db-entirely-desc" [innerHTML]="'text_clearObCacheDesc' | dbText" ></p>
            </div>

            <div class="db-hosting-tools__group-button">
              <a class="ds-btn-black" [ngClass]="{'ds-btn-disabled': clearObCacheLoading}" (click)="clearObCache()">
                <span *ngIf="!clearObCacheLoading" >{{'text_clearCache' | dbText | lowerCaseSpecificWords}}</span>
                <db-loading-circular-spinner *ngIf="clearObCacheLoading"></db-loading-circular-spinner>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="db-hosting-tools__group" *ngIf="!website?.isNetwork || (website?.isNetwork
      && website?.multisiteType === 'subdomain' && website?.parentId) || (website?.isNetwork
      && website?.multisiteType === 'subfolder' && !website?.parentId)">
        <div class="db-hosting-tools__group-each db-ssl-certificates">
          <div class="db-hosting-tools__group-description">
            <p>{{'text_enableHttps' | dbText}}</p>
            <p *ngIf="((addAllDomains && addAllDomains.length) || !addAllDomains) || (removeAllDomains
            && removeAllDomains.length)" [innerHTML]="'text_enableHttpsDesc' | dbText" ></p>
            <p *ngIf="(addAllDomains && !addAllDomains.length) && (removeAllDomains && !removeAllDomains.length)"
               [innerHTML]="'text_enableHttpsDescTrial' | dbText" ></p>
          </div>
          <div class="db-hosting-tools__group-button db-enable-https">
            <div class="db-enable-https-dropdown" *ngIf="((addAllDomains && addAllDomains.length) ||
            (removeAllDomains && removeAllDomains.length))">
              <span *ngIf="httpsEnabled" class="ds-label ds-label-small"><span>{{'text_https_enabled' | dbText}}</span></span>
              <ds-dropdown [dsDropdownWidth]="'180px'" [formControl]="enableHttps"
                           [overflowHidden]="true"
                           [value]="httpsEnabled && ((hostingCertificateData[0].type !== 'free' ) || !addAllDomains) ? 'remove_certificate' : enableHttps.value"
                           [dsDropDownScrollingElement]="'db-hosting-tools'" [dsDropdownOptions]="httpsEnabled
                           && ((hostingCertificateData[0].type !== 'free' ) || !addAllDomains) ?
                           enableCustomHttpsOptions : enableHttpsOptions"></ds-dropdown>
            </div>
            <a class="ds-btn-black" [routerLink]="['../../domains']" *ngIf="(addAllDomains
            && !addAllDomains.length) && (removeAllDomains && !removeAllDomains.length)">
              <span>{{'text_hosting.domainNotPointed' | dbText}}</span>
            </a>
          </div>
        </div>
      </div>
      <div class="db-hosting-tools__group db-php-section" *ngIf="!website?.parentId">
        <div class="db-php-version-tab">
          <div class="db-hosting-tools__group-each db-php-engine-version">
            <div class="db-hosting-tools__group-description">
              <p>{{'text_phpVersion' | dbText}}</p>
              <p class="db-php-version-desc" [innerHTML]="'text_phpEngineDesc' | dbText" ></p>
            </div>
            <div class="db-hosting-tools__group-button db-php-version-dropdown"
                 [ngClass]="{'disabled': !!disablePhpVersionChangeDropdown}"
                 *ngIf="phpEngineOptions.length !== 0">
              <ds-dropdown [formControl]="phpEngine" [dsDropdownWidth]="'180px'"
                           [dsDropDownScrollingElement]="'db-hosting-tools'" [value]="phpEngine.value"
                           [dsDropdownOptions]="phpEngineOptions"></ds-dropdown>
            </div>
          </div>
        </div>
        <div class="ds-notification-warning"
             *ngIf="!isMobile && website?.domain_hash && !phpIsUpToDate">
          <div>
            <i class="db-icon db-icon-ds-info-bg"></i>
            <p>
              <span [innerHTML]="'text_phpNeedsToBeUpdatedTools' | dbText"></span><br/>
            </p>
          </div>
        </div>
        <div class="db-hosting-tools__group-each db-php-restart">
          <div class="db-hosting-tools__group-description">
            <p>{{'text_restartPhp' | dbText}}</p>
            <p [innerHTML]="'text_restartPhpDesc' | dbText" ></p>
          </div>
          <div class="db-hosting-tools__group-button">
            <a class="ds-btn-black" (click)="restartPhp()" [ngClass]="{'ds-btn-disabled': clearCacheLoading}">
              <span *ngIf="!restartPhpLoading">{{'text_restartPhp' | dbText}}</span>
            </a>
          </div>
        </div>
        <div class="db-hosting-tools__group-each" *ngIf="showChangeMainDomain">
          <div class="db-hosting-tools__group-description">
            <p>{{'text_changeMainDomainExtension' | dbText}}</p>
            <p [innerHTML]="'text_changeMainDomainDesc' | dbText" ></p>
          </div>
          <div class="db-hosting-tools__group-button">
            <a class="ds-btn-black" (click)="changeMainDomain()" [ngClass]="{'ds-btn-disabled': clearCacheLoading}">
              <span *ngIf="!changeMainDomainLoading">{{'text_changeMainDomain' | dbText}}</span>
              <db-loading-circular-spinner *ngIf="changeMainDomainLoading"></db-loading-circular-spinner>
            </a>
          </div>
        </div>
        <div class="db-hosting-tools__advanced" [ngClass]="{'show-php-config': !!showAdvanced}">
          <p (click)="showAdvanced = !showAdvanced">
            <span>{{'text_advancedSettings' | dbText}}</span>
            <i class="db-icon db-icon-ds-arrow-small ml4" [ngClass]="{'transform': !!showAdvanced}"></i>
          </p>
        </div>
        <form [formGroup]="phpConfigFormGroup" *ngIf="showAdvanced">
          <div class="db-hosting-tools__group-each">
            <div class="db-hosting-tools__group-description">
              <p>{{'text_phpConfig' | dbText}}</p>
              <p [innerHTML]="'text_phpConfigDesc' | dbText" ></p>
            </div>
            <div class="db-hosting-tools__group-button">
              <a class="ds-btn-black" (click)="!disablePhpConfigBtn && saveAllPhpConfigs()" [ngClass]="{'ds-btn-disabled': phpConfigsLoading || disablePhpConfigBtn}">
                <span *ngIf="!phpConfigsLoading" >{{'text_saveTags' | dbText | lowerCaseSpecificWords}}</span>
                <db-loading-circular-spinner *ngIf="phpConfigsLoading"></db-loading-circular-spinner>
              </a>
            </div>
          </div>
          <div class="db-hosting-tools__php-advanced-configs mt25">
            <div>
              <p>{{'text_executionTime' | dbText}}<i class="db-icon db-icon-info-lined ml8"
                                  [dsTooltip]="'Set the maximum amount of time<br/> (in seconds) that a PHP request is allowed<br/> to run.'"
                                  dsTooltipPosition="right"
                                  dsTooltipSize="small" dsTooltipColor="black" [dsTooltipVisible]="!isMobile">
                                </i>
              </p>
              <ds-dropdown *ngIf="phpConfigFormGroupDefaultValues?.max_execution_time.includes(phpConfigs?.maxExecutionTime)"
                           [ngClass]="{'disabled': !!phpConfigsLoading}"
                           (onOptionChoose)="onChangeDropdown()"
                           formControlName="max_execution_time"
                           [value]="phpConfigs?.maxExecutionTime"
                           [dsDropdownWidth]="'180px'"
                           [dsDropdownOptions]="maxExecutionTimeOptions">
              </ds-dropdown>
              <div *ngIf="!phpConfigFormGroupDefaultValues?.max_execution_time.includes(phpConfigs?.maxExecutionTime)"
                   class="php-config-value ds-input disabled">
                <p>{{phpConfigs?.maxExecutionTime}} s</p>
              </div>
            </div>
            <div>
              <p>{{'text_uploadLimit' | dbText}}<i class="db-icon db-icon-info-lined ml8"
                                [dsTooltip]="'Select the maximum allowed size (in MB)<br/> for an uploaded file.'"
                                dsTooltipPosition="right"
                                dsTooltipSize="small" dsTooltipColor="black" [dsTooltipVisible]="!isMobile"></i></p>
              <ds-dropdown *ngIf="phpConfigFormGroupDefaultValues?.upload_max_filesize.includes(phpConfigs?.uploadMaxFilesize)"
                           [ngClass]="{'disabled': !!phpConfigsLoading}"
                           (onOptionChoose)="onChangeDropdown()"
                           formControlName="upload_max_filesize"
                           [value]="phpConfigs?.uploadMaxFilesize"
                           [dsDropdownWidth]="'180px'"
                           [dsDropdownOptions]="uploadMaxFilesizeOptions">
              </ds-dropdown>
              <div *ngIf="!phpConfigFormGroupDefaultValues?.upload_max_filesize.includes(phpConfigs?.uploadMaxFilesize)"
                   class="php-config-value ds-input disabled">
                <p>{{phpConfigs?.uploadMaxFilesize}} MB</p>
              </div>
            </div>
            <div>
              <p>{{'text_maxPostSize' | dbText}}<i class="db-icon db-icon-info-lined ml8"
                                 [dsTooltip]="'Select the maximum allowed size (in MB)<br/>of a POST request.'"
                                 dsTooltipPosition="right"
                                 dsTooltipSize="small" dsTooltipColor="black" [dsTooltipVisible]="!isMobile"></i></p>
              <ds-dropdown *ngIf="phpConfigFormGroupDefaultValues?.post_max_size.includes(phpConfigs?.postMaxSize)"
                           [ngClass]="{'disabled': !!phpConfigsLoading}"
                           (onOptionChoose)="onChangeDropdown()"
                           formControlName="post_max_size"
                           [value]="phpConfigs?.postMaxSize"
                           [dsDropdownWidth]="'180px'"
                           [dsDropdownOptions]="postMaxSizeOptions"></ds-dropdown>
              <div *ngIf="!phpConfigFormGroupDefaultValues?.post_max_size.includes(phpConfigs?.postMaxSize)"
                   class="php-config-value ds-input disabled">
                <p>{{phpConfigs?.postMaxSize}} MB</p>
              </div>
            </div>
            <div>
              <p>{{'text_memoryLimit' | dbText}}<i class="db-icon db-icon-info-lined ml8"
                                [dsTooltip]="'Set the maximum amount of memory<br/> (in MB) that a PHP request is allowed<br/> to allocate.'"
                                dsTooltipPosition="right"
                                dsTooltipSize="small" dsTooltipColor="black" [dsTooltipVisible]="!isMobile"></i></p>
              <ds-dropdown *ngIf="phpConfigFormGroupDefaultValues?.memory_limit.includes(phpConfigs?.memoryLimit)"
                           [ngClass]="{'disabled': !!phpConfigsLoading}"
                           (onOptionChoose)="onChangeDropdown()"
                           formControlName="memory_limit"
                           [value]="phpConfigs?.memoryLimit"
                           [dsDropdownWidth]="'180px'"
                           [dsDropdownOptions]="memoryLimitOptions"></ds-dropdown>
              <div *ngIf="!phpConfigFormGroupDefaultValues?.memory_limit.includes(phpConfigs?.memoryLimit)"
                   class="php-config-value ds-input disabled">
                <p>{{phpConfigs?.memoryLimit}} MB</p>
              </div>
            </div>
          </div>
        </form>
      </div>
      </div>
  </div>
  <db-loading-screen [ngClass]="{'hidden':!restartPhpLoading && !clearCacheLoading && !clearObCacheLoading}" [fixed]="true"  [loadingMessage]= " restartPhpLoading ? ('text_php_is_restarting' | dbText) : null">
  </db-loading-screen>
  <db-how-to-videos [url]="'https://www.youtube.com/embed/OIF_5GJJ4DY?autoplay=1'"></db-how-to-videos>
</div>
